module.exports = __webpack_public_path__ + "static/media/nf.2087392a.png";